// Angular
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
import { ActionNotificationComponent,
	DeleteEntityDialogComponent,
	FetchEntityDialogComponent,
	UpdateStatusDialogComponent,
	AlertComponent } from '../partials/content/crud';
import { CdkColumnDef } from '@angular/cdk/table';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { InsightsComponent } from './insights/insights.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorAlertComponent } from '../partials/content/crud/error-alert/error-alert.component';
import { AlertNotificationComponent } from '../partials/content/crud/alert-notification/alert-notification.component';
import { ConfirmNotificationComponent } from '../partials/content/crud/confirm-notification/confirm-notification.component';
import { StudentListv2Component } from './student-listv2/student-listv2.component';
import { Communicationv2Component } from './communicationv2/communicationv2.component';
import { Admissionv2Component } from './admissionv2/admissionv2.component';








@NgModule({
	entryComponents: [
		ActionNotificationComponent,
		DeleteEntityDialogComponent,
		AlertComponent,
		FetchEntityDialogComponent,
		UpdateStatusDialogComponent,
		ErrorAlertComponent,
		AlertNotificationComponent,
		ConfirmNotificationComponent
	],
	declarations: [InsightsComponent, StudentListv2Component, Communicationv2Component, Admissionv2Component],
	exports: [],
	imports: [
		CommonModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule ,
		MaterialModule,
		CoreModule,
		PartialsModule,
		BrowserAnimationsModule

	],
	providers: [CdkColumnDef, DatePipe]
})
export class PagesModule {
}
